import React, { useEffect } from 'react';
// ##### 23-11-02 Komarov
import { Media } from '../../../helpers/MediaConfig';

// ##### 24-04-05 Komarov
const SvgTag = ({ width }) => {
  return (
    <svg
      data-component="Hotels"
      version="1.0"
      /* width="510.79999pt"
  height="511.04553pt"
  viewBox="0 0 510.79999 511.04553" */
      width={width}
      viewBox="0 0 576 512"
      preserveAspectRatio="xMidYMid"
      id="svg2"
      sodipodi:docname="Hotel_00_Dark_Blue.svg"
      inkscape:version="1.3 (0e150ed6c4, 2023-07-21)"
      xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
      xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:svg="http://www.w3.org/2000/svg"
    >
      <defs id="defs2" />
      <sodipodi:namedview
        id="namedview2"
        pagecolor="#ffffff"
        bordercolor="#000000"
        borderopacity="0.25"
        inkscape:showpageshadow="2"
        inkscape:pageopacity="0.0"
        inkscape:pagecheckerboard="0"
        inkscape:deskcolor="#d1d1d1"
        inkscape:document-units="pt"
        inkscape:zoom="0.52722268"
        inkscape:cx="527.29143"
        inkscape:cy="289.25159"
        inkscape:window-width="1366"
        inkscape:window-height="705"
        inkscape:window-x="-8"
        inkscape:window-y="-8"
        inkscape:window-maximized="1"
        inkscape:current-layer="svg2"
      />
      <g
        transform="matrix(0.1,0,0,-0.1,-0.6,511.64552)"
        fill="#000000"
        stroke="none"
        id="g2"
        style={{
          fill: '#000080',
        }}
      >
        <path
          d="m 2380,5114 c -19,-2 -78,-9 -130,-14 -330,-36 -695,-160 -990,-336 C 885,4540 580,4235 356,3860 181,3568 65,3228 18,2870 2,2747 2,2373 18,2250 100,1627 374,1100 838,669 1094,430 1413,244 1760,130 2034,39 2251,6 2560,6 c 228,0 329,9 530,50 689,141 1304,583 1674,1204 175,292 291,632 338,990 16,123 16,497 0,620 -47,358 -163,698 -338,990 -224,375 -529,680 -904,904 -289,173 -634,291 -980,336 -88,12 -438,21 -500,14 z m 432,-640 c 430,-59 808,-246 1112,-550 248,-249 422,-552 506,-884 99,-392 74,-810 -69,-1177 C 4205,1464 3915,1121 3550,903 3106,638 2586,563 2080,690 1543,826 1079,1203 826,1708 628,2103 578,2594 690,3040 c 136,537 513,1001 1018,1254 320,161 746,230 1104,180 z"
          id="path1"
          style={{
            fill: '#000080',
          }}
        />
        <path
          d="M 1450,2560 V 1520 h 310 310 l 2,363 3,362 h 485 485 l 3,-362 2,-363 h 310 310 v 1040 1040 h -310 -310 l -2,-362 -3,-363 h -485 -485 l -3,363 -2,362 h -310 -310 z"
          id="path2"
          style={{
            fill: '#000080',
          }}
        />
      </g>
    </svg>
  );
};

// ##### Komarov 2025-07-14
const Hotels = () => {
  return (
    <>
      <Media lessThan="Laptop-1024-1440">
        <SvgTag width="20" />
      </Media>
      <Media greaterThanOrEqual="Laptop-1024-1440">
        <SvgTag width="25%" />
      </Media>
    </>
  );
};

// ##### 25-05-21 Komarov
export default Hotels;
